module.exports = new __parcel__URL__("rope-stanchion.597fab6c.svg").toString();